export default __webpack_public_path__ + "images/ee50159d687b7eb62286705db7f519f6-emoji-hopeful.svg";